var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.385214 13.4229C0.385214 20.4965 6.1195 26.2308 13.1931 26.2308C20.2667 26.2308 26.001 20.4965 26.001 13.4229C26.001 6.34927 20.2667 0.61499 13.1931 0.61499C6.1195 0.61499 0.385214 6.34927 0.385214 13.4229Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWhite);
export default __webpack_public_path__ + "static/media/CircleWhite.8605b00d4e104d49f2817c5aebe3bf85.svg";
export { ForwardRef as ReactComponent };